import React, { Component } from "react";
import Bookmark from "./Bookmark";
// import NewNoteModal from "./NewNoteModal";
// import NoteModal from "./NoteModal";
import { Tab, TabPanel } from "./BookmarkTabs";
import Loading from "../../Shared/Loading";
import "./BookmarksPanel.scss";

export default class BookmarksPanel extends Component {
    onTabClick = key => {
        this.props.setBookmarksSelected(key);
    };

    renderTabs = () => {
        var tabs = [
            <Tab
                onClick={() => {
                    this.onTabClick("my");
                }}
                idKey="my"
                key="my"
                active={
                    !this.props.bookmarksSelected ||
                    this.props.bookmarksSelected === "my"
                }
            >
                My Bookmarks
            </Tab>
        ];
        if (
            !this.props.bookmarks ||
            !this.props.bookmarks.shared ||
            this.props.bookmarks.shared.length === 0
        )
            return tabs;

        for (const user of this.props.bookmarks.shared) {
            tabs.push(
                <Tab
                    onClick={() => {
                        this.onTabClick(user.username);
                    }}
                    key={user.username}
                    idKey={user.username}
                    active={this.props.bookmarksSelected === user.username}
                >
                    <div className="d-flex flex-column">
                        <div className="small text-center">
                            { user.name +
                                " " +
                                user.last_name +
                                (user.last_name.charAt(
                                    user.last_name.length - 1
                                ) === "s" ||
                                user.last_name.charAt(
                                    user.last_name.length - 1
                                ) === "z"
                                    ? "'"
                                    : "'s")
                            }
                        </div>
                    </div>
                </Tab>
            );
        }
        return tabs;
    };

    renderPanels = () => {
        var panels = [
            <TabPanel
                idKey="my"
                key="my"
                active={
                    !this.props.bookmarksSelected ||
                    this.props.bookmarksSelected === "my"
                }
            >
                {this.renderBookmarks(
                    this.props.bookmarks
                        ? this.props.bookmarks.my_bookmarks
                        : undefined
                )}
            </TabPanel>
        ];
        if (
            !this.props.bookmarks ||
            !this.props.bookmarks.shared ||
            this.props.bookmarks.shared === 0
        )
            return panels;

        for (const user of this.props.bookmarks.shared) {
            panels.push(
                <TabPanel
                    idKey={user.username}
                    key={user.username}
                    active={this.props.bookmarksSelected === user.username}
                >
                    {this.renderBookmarks(user.bookmarks, true)}
                </TabPanel>
            );
        }
        return panels;
    };

    renderBookmarks = (bookmarks, sharedBookmark) => {
        if (!bookmarks || bookmarks.length === 0) {
            return <i>No bookmarks found.</i>;
        }

        let bookmarkCards = [];
        for (const bookmark of bookmarks) {
            bookmarkCards.unshift(
                <Bookmark
                    key={bookmark.id}
                    bookmark={bookmark}
                    deleteBookmark={this.props.deleteBookmark}
                    sharedBookmark={sharedBookmark}
                    userInfo={this.props.userInfo}
                    realoadBookmarks={this.props.realoadBookmarks}
                />
            );
        }
        return bookmarkCards;
    };

    render() {
        return (
            <div className="row bookmarks-row animated fadeIn faster mt-lg-4 mt-md-4 mt-sm-2 mt-2">
                {this.props.isLoading ? (
                    <div className="w-100 mt-5">
                        <Loading size="4" />
                    </div>
                ) : (
                    <>
                        <ul className="nav nav-tabs nav-pills w-100">
                            {this.renderTabs()}
                        </ul>
                        <div className="tab-content w-100">
                            {this.renderPanels()}
                        </div>
                    </>
                )}
            </div>
        );
    }
}
